export const DESTINATION_ID = {
    FRANCE: 1,
    BELGIUM: 2,
    NETHERLANDS: 3,
    CZECH_REPUBLIC: 4,
    SWEDEN: 5,
    GERMANY: 6,
    MOROCCO: 7,
    SWITZERLAND: 8,
    NORWAY: 9,
    ITALY: 10,
    DOMINICAN_REPUBLIC: 12,
    AUSTRIA: 13,
    DENMARK: 14,
    PORTUGAL: 15,
    IRELAND: 16,
    POLAND: 17,
    SLOVENIA: 18,
    ROMANIA: 19,
    UNITED_KINGDOM: 20,
    SLOVAKIA: 21,
    TURKEY: 22,
    MALTA: 23,
    TUNISIA: 24,
    HUNGARY: 25,
    BULGARIA: 26,
    FINLAND: 27,
    GREECE: 28,
    ALGERIA: 29,
    CYPRUS: 30,
    RUSSIA: 31,
    EGYPT: 32,
    CROATIA: 33,
    ANDORRA: 34,
    ISRAEL: 35,
    NIGER: 36,
    USA: 37,
    SENEGAL: 38,
    UNITED_ARAB_EMIRATES: 39,
    BOSNIA: 40,
    MALI: 41,
    CANADA: 42,
    BELARUS: 43,
    MAURITANIA: 44,
    LIBYA: 45,
    ICELAND: 46,
    JORDAN: 47,
    INDIA: 48,
    LEBANON: 49,
    ARMENIA: 50,
    SYRIA: 51,
    IVORY_COAST: 52,
    GUADELOUPE: 53,
    MARTINIQUE: 54,
    BRAZIL: 56,
    CAPE_VERDE: 57,
    REUNION: 58,
    BURKINA_FASO: 59,
    COMOROS: 60,
    COSTA_RICA: 61,
    GUYANA: 62,
    VENEZUELA: 63,
    THAILAND: 64,
    CUBA: 65,
    SOUTH_KOREA: 66,
    THE_PHILIPPINES: 67,
    SINGAPORE: 68,
    MEXICO: 69,
    NEPAL: 70,
    NICARAGUA: 71,
    ECUADOR: 72,
    SOUTH_AFRICA: 73,
    AZERBAIJAN: 74,
    ARGENTINA: 75,
    ETHIOPIA: 76,
    NIGERIA: 77,
    VIETNAM: 78,
    YEMEN: 79,
    SRI_LANKA: 80,
    GUATEMALA: 81,
    MADAGASCAR: 82,
    CHILE: 83,
    INDONESIA: 84,
    CHINA: 85,
    KENYA: 86,
    THE_MALDIVES: 87,
    CAMBODIA: 88,
    MONGOLIA: 89,
    TANZANIA: 90,
    BURMA: 91,
    COLOMBIA: 92,
    PERU: 93,
    MALAYSIA: 94,
    LAOS: 95,
    MAYOTTE: 96,
    BOLIVIA: 97,
    AUSTRALIA: 98,
    JAPAN: 99,
    UZBEKISTAN: 100,
    SEYCHELLES: 101,
    ZIMBABWE: 102,
    NEW_ZEALAND: 103,
    TOGO: 104,
    JAMAICA: 105,
    MAURITIUS: 106,
    THE_BAHAMAS: 107,
    NAMIBIA: 108,
    BOTSWANA: 109,
    BANGLADESH: 110,
    BENIN: 111,
    NEW_CALEDONIA: 112,
    ANGOLA: 113,
    BURUNDI: 114,
    ANTARCTICA: 115,
    BALTIC_STATES: 125,
    MONTENEGRO: 126,
    OMAN: 128,
    GEORGIA: 129,
    BELIZE: 130,
    PAPUA_NEW_GUINEA: 131,
    BHUTAN: 132,
    PANAMA: 133,
    FRENCH_POLYNESIA: 134,
    SCOTLAND: 137,
    KYRGYZSTAN: 143,
    ANTILLES: 147,
    VANUATU: 148,
    CAMEROON: 153,
    EL_SALVADOR: 154,
    UKRAINE: 155,
    ESTONIA: 159,
    LATVIA: 160,
    LITHUANIA: 161,
    URUGUAY: 162,
    GREENLAND: 163,
    TAJIKISTAN: 167,
    CONGO: 169,
    ALBANIA: 170,
    TURKMENISTAN: 171,
    KAZAKHSTAN: 172,
    PAKISTAN: 175,
    AFGHANISTAN: 176,
    IRAN: 177,
    IRAQ: 178,
    KUWAIT: 179,
    QATAR: 180,
    SAUDI_ARABIA: 181,
    PALESTINE: 182,
    SOMALIA: 183,
    SOMALILAND: 184,
    ERITREA: 185,
    SUDAN: 186,
    CHAD: 187,
    CENTRAL_AFRICAN_REPUBLIC: 188,
    DEMOCRATIC_REPUBLIC_OF_THE_CONGO: 189,
    UGANDA: 190,
    RWANDA: 191,
    MALAWI: 192,
    MOZAMBIQUE: 193,
    SWAZILAND: 194,
    LESOTHO: 195,
    ZAMBIA: 196,
    GABON: 197,
    EQUATORIAL_GUINEA: 198,
    GHANA: 199,
    LIBERIA: 200,
    SIERRA_LEONE: 201,
    GUINEA: 202,
    GUINEA_BISSAU: 203,
    GAMBIA: 204,
    WESTERN_SAHARA: 205,
    SPITSBERGEN: 206,
    MOLDOVA: 207,
    SERBIA: 208,
    KOSOVO: 209,
    MACEDONIA: 210,
    NORTH_KOREA: 211,
    PARAGUAY: 212,
    SURINAME: 213,
    BRITISH_GUIANA: 214,
    TRINIDAD_AND_TOBAGO: 215,
    BARBADOS: 217,
    GRENADA: 218,
    SAINT_VINCENT_AND_THE_GRENADINES: 219,
    SAINT_LUCIA: 220,
    NETHERLANDS_ANTILLES: 221,
    ARUBA: 222,
    DOMINICA: 223,
    ANTIGUA_AND_BARDUBA: 224,
    SAINT_KITTS_AND_NEVIS: 226,
    MONTSERRAT: 227,
    SAINT_BARTHELEMY: 228,
    SAINT_MARTIN: 229,
    ANGUILLA: 230,
    VIRGIN_ISLANDS_OF_THE_UNITED_STATES: 231,
    BRITISH_VIRGIN_ISLANDS: 232,
    PUERTO_RICO: 233,
    HONDURAS: 234,
    HAITI: 235,
    TAIWAN: 236,
    EAST_TIMOR: 237,
    BRUNEI: 238,
    DJIBOUTI: 239,
    SOLOMON_ISLANDS: 240,
    FIJI: 241,
    FALKLAND_ISLANDS: 242,
    LUXEMBOURG: 243,
    ISLE_OF_MAN: 244,
    FAROE_ISLANDS: 245,
    JERSEY: 246,
    GUERNSEY: 247,
    SOUTH_SANDWICH_ISLANDS: 248,
    KASHMIR: 249,
    LIECHTENSTEIN: 250,
    SAN_MARINO: 251,
    FRENCH_SOUTHERN_AND_ANTARCTIC_LANDS: 253,
    AMERICAN_SAMOA: 254,
    ASHMORE_AND_CARTIER_ISLANDS: 255,
    BAHRAIN: 256,
    MARSHALL_ISLANDS: 257,
    BERMUDA: 258,
    COOK_ISLANDS: 259,
    CAYMAN_ISLANDS: 260,
    NORTHERN_CYPRUS: 261,
    FEDERATED_STATES_OF_MICRONESIA: 262,
    TONGA: 263,
    GUAM: 264,
    HEARD_ISLAND_AND_MCDONALD_ISLANDS: 265,
    NORTHERN_MARIANA_ISLANDS: 266,
    INDIAN_OCEAN_TERRITORIES: 267,
    BRITISH_INDIAN_OCEAN_TERRITORY: 268,
    KIRIBATI: 269,
    MACAO: 270,
    MONACO: 271,
    NIUE: 272,
    NORFOLK_ISLAND: 273,
    NAURU: 274,
    PITCAIRN_ISLANDS: 275,
    PALAU: 276,
    SAINT_PIERRE_AND_MIQUELON: 277,
    SAINT_HELENA: 278,
    SAO_TOME_AND_PRINCIPE: 279,
    TURKS_AND_CAICOS_ISLANDS: 280,
    VATICAN: 281,
    WALLIS_AND_FUTUNA: 282,
    SAMOA: 283,
    SOUTH_SUDAN: 285,
    SPAIN: 286,
    ENGLAND: 287,
    ÅLAND_ISLANDS: 288,
    THE_GALAPAGOS_ISLANDS: 303,
    PATAGONIA: 305,
    BALI: 306,
    CURAÇAO: 309,
    SINT_MAARTEN: 310,
    SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: 311,
    BONAIRE_SAINT_EUSTATIUS_AND_SABA: 315,
    LAPLAND: 335,
    BORNEO: 340,
    WALES: 493,
    IRLANDE_DU_NORD: 494,
};
